import axios from 'axios';
import { MainUrl } from "../constants"

export function createGet(endpoint) {
  return async (token, id) => {
    const response = await axios.get(`${MainUrl}/${endpoint}/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  };
}

export function createGetByText(endpoint){
    return async (token, text) => {
        const response = await axios.get(`${MainUrl}/${endpoint}/?text=${text}`, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
    }
}

export function createPost(endpoint){
    return async (token, body) => {
         const response = await axios.post(`${MainUrl}/${endpoint}/`, body, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return response.data
    }
}

// export const CreateArea = async (token, body) => {
//   const response = await axios.post(`${API_URL}/`, body, {
//     headers: {
//       Authorization: `Bearer ${token}`
//     }
//   });
//   return response.data;
// };
// export const GetByText = async (token, text) => {
    

  
// };